import { createAction, props } from '@ngrx/store';
import { Template } from '../templates/template.model';

export const SetCurrentTemplate = createAction(
    '[Template Page] Set current Template',
    props<{template: Template}>(),
);
